<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-22 17:51:04
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-05-15 10:35:03
 * @Description: file content
 很多客楼盘信息
 -->
<template>
  <div class="t4" v-if="pageInfo&&pageInfo.Extinfo">
    <remote-script
      charset="utf-8"
      src="https://map.qq.com/api/js?v=2.exp&key=MDGBZ-JJD36-HBASY-M23ME-PRFZZ-BMFQP&callback=qqMapCallback"
    ></remote-script>
    <UserCard3></UserCard3>
    <!-- banner -->
    <div
      class="banner"
      v-if="pageInfo.Extinfo.buildingBanner&&pageInfo.Extinfo.buildingBanner.length>0"
    >
      <swiper class="banner_swiper" ref="bannerSwiper" :options="banner.swiperOption">
        <swiperSlide v-for="(item,index) in pageInfo.Extinfo.buildingBanner" :key="index">
          <img :src="item.main_img" @click="tapBanner(item)" />
        </swiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>-->
        <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
      </swiper>
    </div>
    <!-- 项目信息 -->
    <div class="info" v-if="pageInfo.Extinfo.buildingName||pageInfo.Extinfo.unitPrice">
      <div class="houseName" v-if="pageInfo.Extinfo.buildingName">{{pageInfo.Extinfo.buildingName}}</div>
      <div class="huosePrice" v-if="pageInfo.Extinfo.unitPrice">
        参考均价：
        <span>{{pageInfo.Extinfo.unitPrice}}元/平</span>
      </div>
    </div>
    <!-- 项目详情 -->
    <div class="infoTitle" v-if="detailList&&detailList.length>0">
      <span class="bg1">楼盘详情</span>
    </div>
    <div class="detail" v-if="detailList">
      <div class="item" v-for="(item,index) in detailList" :key="index">
        <span class="name">{{item.name}}</span>
        <!-- <span class="value">{{item.value}}</span> -->
        <span class="value" v-html="item.value"></span>
      </div>
    </div>

    <!-- 户型图 -->
    <div class="infoTitle" v-if="floorPlanList&&floorPlanList.length>0">
      <span class="bg2">户型图</span>
    </div>
    <IndexHouse v-if="floorPlanList&&floorPlanList.length>0" :list="floorPlanList"></IndexHouse>
    <!-- <div class="infoTitle" v-if="pageInfo.Extinfo.floorPlan&&pageInfo.Extinfo.floorPlan.length>0">
      <span class="bg2">户型图</span>
    </div>
    <IndexHouse
      v-if="pageInfo.Extinfo.floorPlan&&pageInfo.Extinfo.floorPlan.length>0"
      :list="pageInfo.Extinfo.floorPlan"
    ></IndexHouse>-->

    <!-- 项目卖点 -->
    <div class="infoTitle" v-if="pageInfo.Extinfo.advantage">
      <span class="bg3">项目卖点</span>
    </div>
    <div
      class="houseIntroduce"
      v-if="pageInfo.Extinfo.advantage"
      v-html="pageInfo.Extinfo.advantage"
    ></div>

    <!-- 交通导航 -->
    <div class="infoTitle" v-if="pageInfo.Extinfo.lat">
      <span class="bg4">交通导航</span>
    </div>
    <!-- <div id="t4Map" class="t4Map" v-show="pageInfo.Extinfo.lat" @click="clickMap"></div> -->
    <t7Map v-show="pageInfo.Extinfo.lat"></t7Map>
  </div>
</template>
<script>
window.qqMapCallback = function() {
  let tmpInterval = setInterval(() => {
    if (
      window.t4 &&
      window.t4.pd &&
      window.t4.pd.Extinfo &&
      window.t4.pd.Extinfo.lat
    ) {
      window.initmap();
      clearInterval(tmpInterval);
    }
  }, 500);
};

window.initmap = function() {
  var myLatlng = new qq.maps.LatLng(
    window.t4.pd.Extinfo.lat,
    window.t4.pd.Extinfo.lng
  );
  //获取dom元素添加地图信息
  var map = new qq.maps.Map(document.getElementById("t4Map"), {
    zoom: 13,
    center: myLatlng,
    mapTypeId: qq.maps.MapTypeId.ROADMAP,
    scaleControl: false,
    zoomControl: false
  });
  //给定位的位置添加图片标注
  var markers = new qq.maps.Marker({
    position: myLatlng,
    map: map
  });
  var marker = new qq.maps.Label({
    position: myLatlng,
    map: map,
    content: window.t4.pd.Extinfo.buildingName
  });
};
import "swiper/dist/css/swiper.css";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
const IndexHouse = () => import("@/components/t4/index_house");
const UserCard3 = () => import("@/components/usercard3");
const t7Map = () => import("@/components/t7_map");
import wx from "weixin-js-sdk";
export default {
  components: {
    swiper,
    swiperSlide,
    IndexHouse,
    UserCard3,
    t7Map
  },
  props: {},
  data() {
    return {
      floorPlanList: [],
      pd: {},
      banner: {
        swiperOption: {
          autoplay: {
            delay: 2500
          },
          pagination: {
            el: ".swiper-pagination"
          }
        },
        items: []
      },
      detailList: []
    };
  },
  // 测试的数据?fake=henduoke_hope&id=12115&psn=3de21a22c4ca4deda68126ee087e9652
  watch: {},
  computed: {
    bannerSwiper() {
      return this.$refs.bannerSwiper.swiper;
    },
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_PAGEINFO: "SET_PAGEINFO"
    }),
    scrollEvent() {
      // console.log(
      //   `document.body.scrollTop:${document.body.scrollTop} this.$clientHeight:${this.$clientHeight} document.body.scrollHeight:${document.body.scrollHeight}`
      // );
      if (document.body.scrollHeight - this.$clientHeight > 100) {
        let tmpNum =
          document.body.scrollHeight -
          this.$clientHeight -
          document.body.scrollTop;
        if (tmpNum < 100) {
          this.isShowBubbleShare = true;
        } else {
          this.isShowBubbleShare = false;
        }
      }
    },
    tapBanner(item) {
      if (item.redirect_url && !this.isInMiniProgram) {
        util.openUrl(item.redirect_url);
      }
    },
    clickMap() {
      if (this.isInMiniProgram) {
        wx.openLocation({
          latitude: parseFloat(this.pd.Extinfo.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(this.pd.Extinfo.lng), // 经度，浮点数，范围为180 ~ -180。
          name: this.pd.Extinfo.buildingName, // 位置名
          address: this.pd.Extinfo.address, // 地址详情说明
          scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
        });
      } else {
        util.openUrl(
          `http://uri.amap.com/marker?position=${this.pd.Extinfo.lng},${this.pd.Extinfo.lat}&name=${this.pd.Extinfo.buildingName}`
        );
      }
    },
    filterFloorPlan(item) {
      let that = this;
      item.forEach(function(v, i) {
        let obj = {};
        obj.main_img =
          v.main_img + "?x-oss-process=image/resize,w_300/format,jpg";
        obj.name = v.name;
        that.floorPlanList.push(obj);
      });
      console.log(that.floorPlanList);
    }
  },
  filters: {},
  created() {
    let that = this;
    util.checkMapStateCallback(that, ["hdkUserInfo", "pageInfo"]).then(() => {
      that.pd = that.pageInfo;
      if (that.pd.Extinfo == "") {
        that.pd.Extinfo = that.json;
        return;
      }

      if (that.pd.Extinfo.floorPlan && that.pd.Extinfo.floorPlan.length > 0) {
        that.filterFloorPlan(that.pd.Extinfo.floorPlan);
      }

      let name1 = {
        buildingName: "楼盘名称",
        address: "楼盘地址",
        developer: "开发商",
        propertyManagement: "物业公司"
      };

      let name2 = {
        buildingType: "建筑类型",
        propertyType: "物业类型",
        navigationUrl: "导航链接",
        lng: "经度",
        lat: "纬度",
        unitPrice: "单价（元/平米）",
        propertyYears: "产权年限(年)",
        parkingRatio: "车位占比(%)",
        decorateLevel: "装修标准",
        greenRatio: "绿化率(%)",
        volumeRatio: "容积率(%)",
        propertyCosts: "物业费(元/m²)"
      };
      if (that.pd.Extinfo.fyqBuildingId) {
        // 兼容房友圈 开始
        if (that.pd.Extinfo.imageList) {
          that.pd.Extinfo.imageList = JSON.parse(that.pd.Extinfo.imageList);
          console.log(
            "that.pd.Extinfo.imageList",
            JSON.parse(JSON.stringify(that.pd.Extinfo.imageList))
          );
          that.pd.Extinfo.buildingBanner = that.pd.Extinfo.imageList.map(
            item => {
              item.main_img = item.imageUrl;
              return item;
            }
          );
        }
        if (that.pd.Extinfo.layoutList) {
          that.pd.Extinfo.layoutList = JSON.parse(that.pd.Extinfo.layoutList);
          console.log(
            "that.pd.Extinfo.layoutList",
            JSON.parse(JSON.stringify(that.pd.Extinfo.layoutList))
          );
          that.floorPlanList = that.pd.Extinfo.layoutList.map(item => {
            if (item.layoutImageList && item.layoutImageList.length > 0) {
              var layoutImageListItem = JSON.parse(item.layoutImageList[0]);
              item.compress_img = layoutImageListItem.ImageUrl;
              item.main_img = layoutImageListItem.ImageUrl;
              return item;
            }
          });
        }

        name1 = {
          buildingName: "楼盘名称",
          fullAddress: "楼盘地址",
          salesAddress: "售楼地址",
          developer: "开发商",
          propertyManagement: "物业公司"
        };

        name2 = {
          license: "预售许可证",
          features: "楼盘特色",
          status: "状态",
          // buildingType: "建筑类型",
          buildingCategory: "建筑类别",
          buildingArea: "建筑面积",
          households: "规划户数",
          propertyType: "物业类型",
          navigationUrl: "导航链接",
          lng: "经度",
          lat: "纬度",
          unitPrice: "单价（元/平米）",
          propertyYears: "产权年限(年)",
          parkingRatio: "车位占比(%)",
          decorateLevel: "装修标准",
          greenRatio: "绿化率(%)",
          volumeRatio: "容积率(%)",
          propertyCosts: "物业费(元/m²)",
          // supporting: "周边配套",
          // travel: "交通信息",
          liveFacilities: "周边配套",
          trafficNavigation: "交通信息"
        };
        that.pd.Extinfo.lat = that.pd.Extinfo.lat || that.pd.Extinfo.latitude;
        that.pd.Extinfo.lng = that.pd.Extinfo.lng || that.pd.Extinfo.longitude;
        // 兼容房友圈 结束
      }

      let names = {};
      let buildingType = [
        "建筑类型:",
        "低层住宅",
        "多层住宅",
        "小高层住宅",
        "高层住宅",
        "商业",
        "办公",
        "高层办公",
        "洋房"
      ];
      let propertyType = [
        "物业类型:",
        "住宅",
        "酒店式公寓",
        "住宅式公寓",
        "别墅",
        "办公楼",
        "商铺",
        "商业",
        "养老度假村"
      ];
      let decorateLevel = ["装修类别:", "毛坯", "中装", "简装", "精装", "豪装"];
      let bookDate = that.pd.Extinfo.bookDate;
      let deliverDate = that.pd.Extinfo.deliverDate;
      if (bookDate && bookDate.toString().indexOf("-") > 0) {
        bookDate = that.pd.Extinfo.bookDate.split("-");
        name1 = {
          ...name1,
          bookDate: "开盘时间"
        };
      }
      if (deliverDate && deliverDate.toString().indexOf("-") > 0) {
        deliverDate = that.pd.Extinfo.deliverDate.split("-");
        name1 = {
          ...name1,
          deliverDate: "交房时间"
        };
      }
      names = {
        ...name1,
        ...name2
      };
      for (let keys in names) {
        for (let key in that.pd.Extinfo) {
          let obj = {};
          if (keys == key) {
            obj.name = names[keys];
            if (names[keys] == "装修标准") {
              obj.value = decorateLevel[that.pd.Extinfo[key]]
                ? decorateLevel[that.pd.Extinfo[key]]
                : "待定";
            } else if (names[keys] == "开盘时间" && bookDate) {
              obj.value = `预计${bookDate[0]}年${bookDate[1]}月份`
                ? `预计${bookDate[0]}年${bookDate[1]}月份`
                : "待定";
            } else if (names[keys] == "交房时间" && deliverDate) {
              obj.value = `预计${deliverDate[0]}年${deliverDate[1]}月份`
                ? `预计${deliverDate[0]}年${deliverDate[1]}月份`
                : "待定";
            } else if (names[keys] == "物业类型") {
              obj.value = propertyType[that.pd.Extinfo[key]]
                ? propertyType[that.pd.Extinfo[key]]
                : "待定";
            } else if (names[keys] == "建筑类型") {
              obj.value = buildingType[that.pd.Extinfo[key]]
                ? buildingType[that.pd.Extinfo[key]]
                : "待定";
            } else {
              obj.value = that.pd.Extinfo[key] ? that.pd.Extinfo[key] : "待定";
            }
            that.detailList.push(obj);
          }
        }
      }

      that.SET_PAGEINFO(that.pd);
      window.t4 = {
        pd: that.pd
      };
      if (
        that.pageInfo.Actuuid &&
        that.hdkUserInfo.User &&
        that.hdkUserInfo.User.Id &&
        that.pageInfo.Actuuid == that.hdkUserInfo.User.Id
      ) {
        that.isCanEdit = true;
      }
    });
    window.addEventListener("scroll", that.scrollEvent, true);
  },
  mounted() {
    this.editHeight = this.$clientHeight - this.$tabbarHeight;
  }
};
</script>


<style lang="css" scoped>
/* Banner */
.banner {
  margin-top: 8px;
}
.banner_swiper {
  width: 100%;
  height: 4.97rem;
}
.banner_swiper img {
  width: 100%;
  height: 4.97rem;
  object-fit: cover;
}
/* 项目信息 */
.info {
  width: 90%;
  min-height: 1.8rem;
  margin: 0 auto;
  padding: 0.3rem 0;
  box-sizing: border-box;
}
.info .houseName {
  width: 100%;
  height: 0.7rem;
  line-height: 0.6rem;
  font-weight: 600;
  color: #333333;
  font-size: 0.46rem;
}
.info .huosePrice {
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.32rem;
}
.info .huosePrice > span {
  color: #ff5d7a;
}
/* infoTitle */
.infoTitle {
  width: 100%;
  margin: 0 auto;
}
.infoTitle > span {
  height: 0.68rem;
  min-width: 1.5rem;
  padding: 0rem 0.3rem;
  line-height: 0.6rem;
  font-size: 0.32rem;
  color: #fff;
  display: inline-block;
}
.bg1 {
  background: url(https://assets.rurushishi.com/yq-rs-make/t4/1.png) no-repeat;
  background-size: 100% 100%;
}
.bg2 {
  background: url(https://assets.rurushishi.com/yq-rs-make/t4/2.png) no-repeat;
  background-size: 100% 100%;
}
.bg3 {
  background: url(https://assets.rurushishi.com/yq-rs-make/t4/3.png) no-repeat;
  background-size: 100% 100%;
}
.bg4 {
  background: url(https://assets.rurushishi.com/yq-rs-make/t4/4.png) no-repeat;
  background-size: 100% 100%;
}
/* 项目详情 */

.detail {
  background-color: #fff;
  padding: 0 0.5rem;
  top: -0.125rem;
  position: relative;
  border-top-left-radius: 0.125rem;
  border-top-right-radius: 0.125rem;
}

.detail .item {
  display: flex;
  align-items: baseline;
  margin: 0.25rem 0;
}

.detail .item .name {
  font-size: 0.28rem;
  /* font-weight: 500; */
  width: 30%;
  padding: 0;
  color: #7b7b7b;
}

.detail .item .value {
  font-size: 0.28rem;
  width: 70%;
  line-height: 0.4rem;
}

/* 项目卖点 */
.houseIntroduce {
  width: 90%;
  margin: 0 auto;
  line-height: 0.5rem;
  padding: 0.2rem 0;
  color: #7b7b7b;
  font-size: 0.28rem;
}
.t4Map {
  margin: 0.3rem 0;
  width: 100%;
  height: 5rem;
}
</style>